export const normalizeRut = (value) => (value || '').replace(/\D/g, '');

const isSimpleSequence = (value) => (
  '01234567890123456789'.includes(value) ||
  '98765432109876543210'.includes(value)
);

/** RUT uruguayo de 12 dígitos con dígito verificador correcto (descarta repetidos y secuencias obvias). */
export const isValidRut = (value) => {
  const rut = normalizeRut(value);
  if (rut.length !== 12) return false;
  if (rut.split('').every((digit) => digit === rut[0])) return false;
  if (isSimpleSequence(rut)) return false;

  const weights = [4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const sum = rut.slice(0, 11).split('').reduce((acc, digit, index) => acc + Number(digit) * weights[index], 0);
  const candidate = 11 - (sum % 11);
  const expected = candidate > 9 ? 0 : candidate;
  return expected === Number(rut[11]);
};
